import { jsxs as C, jsx as l } from "react/jsx-runtime";
function t(i) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "50",
      height: "50",
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ C("g", { "clip-path": "url(#clip0_244030_522)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M17.2401 32.2565C16.2565 31.5921 15.5756 30.6217 15.2039 29.3388L17.4868 28.3979C17.694 29.1874 18.0558 29.7992 18.5723 30.2335C19.0855 30.6677 19.7105 30.8815 20.4408 30.8815C21.1875 30.8815 21.829 30.6546 22.3651 30.2006C22.9013 29.7467 23.171 29.1677 23.171 28.467C23.171 27.7499 22.8881 27.1644 22.3223 26.7104C21.7565 26.2565 21.046 26.0295 20.1973 26.0295H18.8783V23.7696H20.0625C20.7927 23.7696 21.4079 23.5723 21.9079 23.1775C22.4079 22.7828 22.6579 22.2434 22.6579 21.5559C22.6579 20.944 22.4341 20.4571 21.9868 20.0921C21.5394 19.727 20.9736 19.5428 20.2861 19.5428C19.615 19.5428 19.0822 19.7204 18.6874 20.079C18.2926 20.4376 18.0064 20.8783 17.8255 21.398L15.5657 20.4572C15.865 19.6085 16.4144 18.8585 17.2203 18.2105C18.0262 17.5625 19.0558 17.2368 20.3058 17.2368C21.2301 17.2368 22.0624 17.4145 22.7993 17.773C23.5361 18.1316 24.1151 18.6283 24.5329 19.2599C24.9506 19.8947 25.1579 20.6053 25.1579 21.3947C25.1579 22.2007 24.9638 22.8815 24.5756 23.4408C24.1875 24 23.7105 24.4276 23.1447 24.727V24.8619C23.8914 25.1744 24.5 25.6514 24.9802 26.2929C25.4572 26.9343 25.6973 27.7008 25.6973 28.5955C25.6973 29.4902 25.4704 30.2895 25.0164 30.9902C24.5625 31.6909 23.9341 32.2436 23.138 32.6448C22.3387 33.0461 21.4407 33.2501 20.444 33.2501C19.2894 33.2533 18.2237 32.9211 17.2401 32.2565Z",
              fill: "#0085F7"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M31.2632 20.9277L28.7565 22.7402L27.5033 20.8388L32 17.5955H33.7237V32.8948H31.2632V20.9277Z",
              fill: "#0085F7"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M38.1579 38.158H11.8421L8.07507 43.7084L11.8421 50H38.1579L41.27 43.3061L38.1579 38.158Z",
              fill: "#00A94B"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M38.1579 0H3.94736C1.76641 0 0 1.76641 0 3.94736V38.1579L5.92109 42.3672L11.8422 38.1579V11.8421H38.158L42.209 5.921L38.1579 0Z",
              fill: "#0085F7"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0 38.158V46.0527C0 48.2336 1.76641 50 3.94736 50H11.8421V38.158H0Z",
              fill: "#00802E"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M50 11.8422L44.079 8.03223L38.158 11.8422V38.158L43.4831 40.9376L50 38.158V11.8422Z",
              fill: "#FFBC00"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M50 11.8421V3.94736C50 1.76641 48.2336 0 46.0527 0H38.158V11.8421H50Z",
              fill: "#0067D5"
            }
          ),
          /* @__PURE__ */ l("path", { d: "M38.158 50L50 38.158H38.158V50Z", fill: "#FF4131" })
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_244030_522", children: /* @__PURE__ */ l("rect", { width: "50", height: "50", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
export {
  t as GoogleCalendarIcon
};
